import React from 'react'
import PropTypes from 'prop-types'
import { ModalWrapper, DownloadMenu } from 'components'
import { Download } from '@dsny/dsny-component-library/icons'

class DownloadButton extends React.Component {
  static propTypes = {
    // release: PropTypes.object,
    render: PropTypes.func,
    widthClassName: PropTypes.string
  }

  static defaultProps = {
    // release: null
  }

  state = {
    isOpen: false
  }

  handleClickButton = () => {
    this.setState({ isOpen: true })
  }

  handleClickOutside = () => {
    setTimeout(() => this.setState({ isOpen: false }), 0)
  }

  renderButton = () => {
    const { render, widthClassName } = this.props
    if (render) {
      return render({ handleClick: this.handleClickButton })
    } else {
      return (
        <button
          type="button"
          className="focus:outline-none w-full mt-2"
          onClick={this.handleClickButton}>
          <Download
            style={{ color: '#EBEBEB', width: 22 }}
            className={`${widthClassName ? widthClassName : 'w-4'}`} />
        </button>
      )
    }
  }

  renderMenu = () => {
    const { isOpen } = this.state
    if (isOpen) {
      return (
        <div
          className="absolute mt-10 inset-y-0 right-0"
          style={{ zIndex: 300 }}>
          <ModalWrapper onClickOutside={this.handleClickOutside}>
            <DownloadMenu />
          </ModalWrapper>
        </div>
      )
    } else {
      return null
    }
  }

  render() {
    return (
      <div className="relative">
        {this.renderButton()}
        {this.renderMenu()}
      </div>
    )
  }
}

export default DownloadButton
